"use strict";exports.__esModule=!0,exports.VALID_LOG_LEVELS=void 0,exports.VALID_LOG_LEVELS=["error","warn","log","info","debug","trace"];